import React from "react"

const Xyz=()=>{
   return (
     <h1>Xyz</h1>
   )
}

export default Xyz